var _g, _path, _rect, _rect2, _path2, _rect3, _rect4, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 128,
    viewBox: "0 0 125 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_236_467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7043 74.6198C46.8321 63.7011 55.9666 38.508 57.884 34.6732L62.6776 32.2764L67.8707 34.6732C72.2648 47.8556 80.7335 74.6198 82.6509 74.6198C85.0477 74.6198 94.2355 79.4134 97.0317 79.8129C99.2688 80.1325 99.2954 82.3428 99.0291 83.4081L62.6776 101.784L26.3262 82.2097L42.7043 74.6198Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.7701 75.4477C58.1084 75.4477 54.0801 74.7383 50.6852 73.3195C47.2903 71.9008 45.4661 70.178 45.2128 68.1511C45.9222 66.175 46.6316 64.1482 47.3409 62.0707C48.101 59.9932 48.8611 57.9157 49.6211 55.8382C50.1278 57.3583 51.6226 58.5997 54.1055 59.5625C56.639 60.4745 59.5272 60.9306 62.7701 60.9306C66.0131 60.9306 68.8759 60.4745 71.3588 59.5625C73.8923 58.5997 75.4124 57.3583 75.9192 55.8382C76.6792 57.9157 77.4139 59.9932 78.1233 62.0707C78.8834 64.1482 79.6181 66.175 80.3275 68.1511C80.0741 70.178 78.25 71.9008 74.8551 73.3195C71.4601 74.7383 67.4318 75.4477 62.7701 75.4477ZM62.7701 49.3017C60.5913 49.3017 58.5898 48.9977 56.7657 48.3896C54.9415 47.7816 53.7254 46.9455 53.1174 45.8814C53.9788 43.5506 54.7388 41.4477 55.3976 39.5729C56.0563 37.6474 56.6137 36.0767 57.0697 34.8606C57.3737 33.9992 58.0831 33.3658 59.1979 32.9604C60.3633 32.5044 61.554 32.2764 62.7701 32.2764C63.9862 32.2764 65.1517 32.5044 66.2664 32.9604C67.4318 33.3658 68.1666 33.9992 68.4706 34.8606C68.9266 36.0767 69.484 37.6474 70.1427 39.5729C70.8014 41.4477 71.5615 43.5506 72.4229 45.8814C71.8148 46.9455 70.5987 47.7816 68.7746 48.3896C66.9505 48.9977 64.949 49.3017 62.7701 49.3017ZM96.9728 79.248C98.9996 80.0587 100.038 81.1481 100.089 82.5163C100.19 83.8337 99.2783 84.9991 97.3528 86.0125L69.8387 100.758C67.9132 101.822 65.557 102.354 62.7701 102.354C59.9833 102.354 57.6271 101.822 55.7016 100.758L28.1875 86.0125C26.262 84.9991 25.3246 83.8337 25.3752 82.5163C25.4766 81.1481 26.5407 80.0587 28.5675 79.248L43.2366 73.3955L41.5645 78.0319C41.5645 79.2987 42.1219 80.4894 43.2366 81.6042C44.402 82.6683 45.9475 83.6057 47.873 84.4164C49.7985 85.2271 52.0533 85.8605 54.6375 86.3165C57.171 86.7726 59.8819 87.0006 62.7701 87.0006C65.6584 87.0006 68.3692 86.7726 70.9028 86.3165C73.487 85.8605 75.7418 85.2271 77.6673 84.4164C79.5928 83.6057 81.1382 82.6429 82.3036 81.5282C83.4184 80.4641 83.9758 79.2987 83.9758 78.0319L82.3036 73.3955L96.9728 79.248Z",
    fill: "#F05319"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82.3791,
    y: 19.1984,
    width: 28.2229,
    height: 28.2229,
    rx: 3.99138,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.3791,
    y: 19.1984,
    width: 28.2229,
    height: 28.2229,
    rx: 3.99138,
    stroke: "#5CC92F",
    strokeWidth: 2.3968
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.191 29.6206C103.599 29.2181 103.599 28.5654 103.191 28.1628C102.783 27.7602 102.122 27.7602 101.714 28.1628L93.8111 35.9651L90.2288 32.4285C89.821 32.0258 89.1599 32.0258 88.7521 32.4285C88.3443 32.831 88.3443 33.4838 88.7521 33.8863L92.7036 37.7875C93.3153 38.3914 94.307 38.3914 94.9186 37.7875L103.191 29.6206Z",
    fill: "#5CC92F",
    stroke: "#5CC92F",
    strokeWidth: 0.798933
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1984,
    y: 19.1984,
    width: 28.2229,
    height: 28.2229,
    rx: 3.99138,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1984,
    y: 19.1984,
    width: 28.2229,
    height: 28.2229,
    rx: 3.99138,
    stroke: "#D7E5ED",
    strokeWidth: 2.3968
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4235 39.3019C24.9938 39.3019 24.602 39.1343 24.2481 38.7993C23.8942 38.4643 23.7173 38.0777 23.7173 37.6396C23.7173 37.2272 23.8816 36.8406 24.2102 36.4798L26.8264 33.7351C26.978 33.5289 27.0538 33.3485 27.0538 33.1939C27.0538 32.9877 26.978 32.8073 26.8264 32.6527L24.1723 29.9466C23.9195 29.6116 23.7931 29.2765 23.7931 28.9415C23.7931 28.5034 23.9827 28.1297 24.3618 27.8204C24.741 27.4854 25.1581 27.3179 25.6131 27.3179C26.0933 27.3179 26.4725 27.4983 26.7505 27.8591L28.8738 30.3719C29.0255 30.5265 29.1771 30.6038 29.3288 30.6038C29.531 30.6038 29.6827 30.5265 29.7838 30.3719L31.8691 27.8591C32.1472 27.4983 32.5263 27.3179 33.0066 27.3179C33.4616 27.3179 33.8786 27.4854 34.2578 27.8204C34.6369 28.1297 34.8265 28.5163 34.8265 28.9802C34.8265 29.2894 34.7001 29.6116 34.4474 29.9466L31.7933 32.6527C31.6416 32.8073 31.5658 32.9877 31.5658 33.1939C31.5658 33.3485 31.6416 33.5289 31.7933 33.7351L34.4094 36.4798C34.738 36.8406 34.9023 37.2272 34.9023 37.6396C34.9023 38.0777 34.7254 38.4643 34.3715 38.7993C34.0177 39.1343 33.6259 39.3019 33.1962 39.3019C32.7412 39.3019 32.362 39.1086 32.0587 38.722L29.7838 35.9773C29.6827 35.8226 29.531 35.7453 29.3288 35.7453C29.1771 35.7453 29.0255 35.8226 28.8738 35.9773L26.5609 38.722C26.384 38.9282 26.1944 39.0699 25.9922 39.1472C25.8153 39.2503 25.6257 39.3019 25.4235 39.3019Z",
    fill: "#D7E5ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_236_467",
    x: 0.760317,
    y: 6.71051,
    width: 123.949,
    height: 120.639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.7829
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.34902 0 0 0 0 0.517647 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_236_467",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_cone.dec7203b2efab8c7481197182cd96432.svg";